import React, {useEffect, useState} from "react";
import PlanSelectItem from "./PlanSelectItem";
import {getAmountLabel} from "../../../helpers/helpers";
import GenericItem from "../items/GenericItem";

const PlanSelectItemHeader = ({selectedPlan, planSelectLabel, doNotRenew,
                                  isEligibleForFreeTrial, payNow}) => {
    return (
        <>
            {
                isEligibleForFreeTrial && (
                    <GenericItem details={i18n.payments.checkoutFreeTrial}/>
                )
            }

            {
                !payNow && (
                    <GenericItem details={i18n.payments.checkoutAttachingPaymentMethod}/>
                )
            }

            <div className={'row'}>
                <div className={'col-4'}/>
                <div className={'col-4'}>
                    <PlanSelectItem selected={true}
                                    label1={planSelectLabel}
                                    label2={getAmountLabel(selectedPlan?.priceAmount, selectedPlan?.months)}
                                    doNotRenew={doNotRenew}
                                    readOnly={true}/>
                </div>
                <div className={'col-4'}/>
            </div>
        </>
    );
};

export default PlanSelectItemHeader;